import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';

import {
    Box,
    useTheme,
    Tooltip,
    Divider,
    Select,
    Grid,
    Tabs,
    Card,
    CardContent,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    TextField,
    FormControl,
    Button,
    CssBaseline,
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText
} from "@mui/material";



import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import Close from '@mui/icons-material/Close';
import { Delete, Add } from '@mui/icons-material';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import AppBarModule from "../../../Layout/AppbarModule";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import CallAlertBar from "../../../Layout/Alertbar";
// import SkeletonTableLoader from "../../../pages/productionmanagement/SkeletonTableLoader";

import { tokens } from "../../../theme/theme";


import useBreakTypeList from "../../../hooks/useBreakTypeList";
import useShiftCodeValidation from "../../../hooks/useShiftCodeValidation";
import useShiftMasterList from "../../../hooks/useShiftMasterList";
import useAddShift from "../../../hooks/useAddShift";
import useShiftDetailLoader from "../../../hooks/useShiftDetailLoader";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 0 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}



const ShiftMasterForm = ({ handleBackWinderMachineEntry }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // state variable declartion
    const [shiftCode, setShiftCode] = useState('');
    const [checkInTime, setCheckInTime] = useState(null);
    const [checkOutTime, setCheckOutTime] = useState(null);
    const [editShiftID, setShiftID] = useState(0);
    const [breakDurationMins, setBreakDurationMins] = useState(0);
    const [description, setDescription] = useState('');
    const [newShift, setNewShift] = useState(false);
    const [msgOpen, setMsgOpen] = useState(false);  // message Process
    const [severityValue, setSeverityvalue] = useState('info');
    const [messageValue, setMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [alertTitleValue, setAlertTitleValue] = useState('');
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [selectedButton, setSelectedButton] = useState(null);
    const [value, setValue] = React.useState(0);
    const [loading, setLoading] = useState(false);  //skeleton page     
    const [breaks, setBreaks] = useState([]);//break details
    const [selectedStatus, setSelectedStatus] = useState('All');

    // call message
    const CallMessage = (serverityval, msg, title) => {
        setSeverityvalue(serverityval);
        setMessageValue(msg);
        setAlertTitleValue(title);
        setMsgOpen(true);
    };

    // hooks
    const { shiftData, setShiftData, refreshList } = useShiftMasterList();
    const { breakTypeList, setBreakTypeList, selectBreakType, selectBreakTypeID, loadBreakTypeListByID, } = useBreakTypeList();
    const { shiftCodeStatus, setShiftCodeStatus, checkShiftCode } = useShiftCodeValidation();
    const { addShift } = useAddShift({ shiftCodeStatus, setShiftID, CallMessage, loading, setLoading });
    const { loadShiftDetail } = useShiftDetailLoader({ setShiftCode, setCheckInTime, setCheckOutTime, setBreakDurationMins, setDescription, setBreaks, setLoading, }); // Hook instance with setters

    const addBreakRow = () => {
        setBreaks([
            ...breaks,
            {
                break_type_id: '',
                break_start_time: null,
                break_end_time: null,
                status: 'Active'
            }
        ]);
    };

    const updateBreakField = (index, field, value) => {
        const updated = [...breaks];
        updated[index][field] = value;
        setBreaks(updated);
    };

    const deleteBreakRow = (index) => {
        const updated = [...breaks];
        updated.splice(index, 1);
        setBreaks(updated);
    };

    const handleShowNewVendor = () => {
        setNewShift(true);
        setShiftID(0);
        refreshData();
        setBreaks([]);
    }

    const refreshData = () => {
        setMsgOpen(false);
        setShiftCode('');
        setCheckInTime(null);
        setCheckOutTime(null);
        setDescription('');
        setBreakDurationMins(0);
    }

    const handleCallEdit = async (value) => {
        setShiftID(value);
        setNewShift(true);
        loadShiftDetail(value);
    };

    const addShiftAsync = async () => {
        const success = await addShift({
            shiftCode,
            checkInTime,
            checkOutTime,
            breakDurationMins,
            description,
            breaks,
            editShiftID,
        });

        if (success) {
            // additional logic if needed
        }
    };

    //call back Form
    const callback = () => {
        handleBackWinderMachineEntry();
    };

    const callBackNewShift = () => {
        setNewShift(false);
        setIsDataLoaded(false);
        refreshList();
    };

    // Use it inside useEffect or any function
    useEffect(() => {
        if (editShiftID > 0) {
            loadShiftDetail(editShiftID);
        }
    }, [editShiftID]);

    const handleChange = (event, newValue) => { setValue(newValue); };
    const handleChangeIndex = (index) => { setValue(index); };

    // filter
    const [filters, setFilters] = useState({
        name: '',
        companyname: '',
        email: '',
        workphone: '',
        status: '',
        payales: '',
    });

    // filter data 
    const filteredData = shiftData.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    // handle menu

    const handleMenuList = async (status) => {
        if (status === 'All Shift') {
            setSelectedStatus('All');
        }
        else if (status === 'Active Shift') {
            setSelectedStatus('Active');
        }
        else if (status === 'Inactive Shift') {
            setSelectedStatus('In Active');
        }
    };

    return (
        <Box sx={{ marginTop: "0px" }}>

            {newShift === false && (
                <>
                    <AppBarModule
                        title="Shift Management"
                        menuOptions={['All Shift', 'Active Shift', 'Inactive Shift']}
                        onNewClick={() => handleShowNewVendor()}
                        onClose={() => callback()}
                        menuList={handleMenuList}

                    />


                    {/* Message box detail */}
                    <CallAlertBar
                        parentRollMsgOpen={msgOpen}
                        setParentRollMsgOpen={setMsgOpen}
                        parentRollSeverityvalue={severityValue}
                        setParentRollSeverityvalue={setSeverityvalue}
                        parentRollAlertTitleValue={alertTitleValue}
                        setParentRollAlertTitleValue={setAlertTitleValue}
                        parentRollMessageValue={messageValue}
                        setParentRollMessageValue={setMessageValue} />
                </>
            )}

            <ResponsiveBox
                customMaxHeight={{
                    xs: '60vh',  // Custom value for extra small devices
                    sm: '65vh',  // Custom value for small devices
                    md: '70vh',  // Custom value for medium devices
                    lg: '81vh',  // Custom value for large devices
                    xl: '80vh',  // Custom value for extra large devices
                }}>

                <Grid>
                    {newShift === false && (
                        <>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                                <CustomTableContainer colors={colors}>
                                    <TableContainer>
                                        {loading ? (
                                            <SkeletonTableLoader rows={5} columns={6} />
                                        ) : (
                                            <Table>
                                                <TableHead sx={{ height: 10 }}>
                                                    <TableRow>
                                                        <TableCell>No</TableCell>
                                                        <TableCell>SHIFT CODE</TableCell>
                                                        <TableCell>DESCRIPTION</TableCell>
                                                        <TableCell>START AT</TableCell>
                                                        <TableCell>END AT</TableCell>
                                                        <TableCell>STATUS</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {filteredData.map((s) => (
                                                        <React.Fragment key={s.id}>
                                                            <TableRow>
                                                                <TableCell>{s.id}</TableCell>
                                                                <TableCell>
                                                                    <span
                                                                        style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                                        onClick={() => handleCallEdit(s.id)}
                                                                    >
                                                                        {s.code}
                                                                    </span>
                                                                </TableCell>
                                                                <TableCell>{s.s_description}</TableCell>
                                                                <TableCell>{s.start_at}</TableCell>
                                                                <TableCell>{s.end_at}</TableCell>
                                                                <TableCell>{s.status}</TableCell>
                                                            </TableRow>
                                                        </React.Fragment>
                                                    ))}

                                                </TableBody>
                                            </Table>
                                        )}
                                    </TableContainer>
                                </CustomTableContainer>
                            </Grid>
                        </>
                    ) || (
                            <>
                                <Grid item xs={12} sm={6} md={4} lg={2}  >

                                    <Grid container justifyContent="space-between" alignItems="center" padding={0}>
                                        {/* Left-aligned: Edit Employee */}
                                        <Grid item>
                                            <Typography variant="h4" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>
                                                {editShiftID === 0 ? 'Add Shift Detail' : 'Edit Shift Detail'}
                                            </Typography>
                                        </Grid>

                                        {/* Right-aligned: Buttons */}
                                        <Grid item>
                                            <Grid container alignItems="center">
                                                {editShiftID !== 0 && (
                                                    <>
                                                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                                                        {/* Save */}
                                                        <Grid item ml={1} mr={1}>
                                                            <Tooltip title="Add new orders">
                                                                <IconButton
                                                                    onClick={() => handleShowNewVendor()}
                                                                    sx={{ display: 'flex', alignItems: 'center' }}
                                                                    type="submit"
                                                                >
                                                                    <AddCircleIcon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                                                                    <Typography variant="body2" sx={{ ml: 1 }}>Add New</Typography>
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Grid>
                                                    </>
                                                )}
                                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                                                {/* Save */}
                                                <Grid item ml={1} mr={1}>
                                                    <Tooltip title="Add new orders">
                                                        <IconButton
                                                            onClick={() => addShiftAsync()}
                                                            sx={{ display: 'flex', alignItems: 'center' }}
                                                            type="submit"
                                                        >
                                                            <ReceiptRoundedIcon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                                                            <Typography variant="body2" sx={{ ml: 1 }}>  {editShiftID === 0 ? 'Save' : 'Edit'}</Typography>
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>

                                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                                                <IconButton onClick={callBackNewShift}>
                                                    <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                                                </IconButton>

                                                <Divider orientation="vertical" flexItem />

                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Divider />
                                    
                                    <CallAlertBar
                                        parentRollMsgOpen={msgOpen}
                                        setParentRollMsgOpen={setMsgOpen}
                                        parentRollSeverityvalue={severityValue}
                                        setParentRollSeverityvalue={setSeverityvalue}
                                        parentRollAlertTitleValue={alertTitleValue}
                                        setParentRollAlertTitleValue={setAlertTitleValue}
                                        parentRollMessageValue={messageValue}
                                        setParentRollMessageValue={setMessageValue} />
                                </Grid>


                                {/* Add Form detail */}
                                <Grid item xs={12} sm={6} md={4} lg={2}>
                                    <Grid container>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                    <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                            Shift Code
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={11} md={3.8} lg={5} xl={4}>
                                                        <TextField required value={shiftCode} onChange={(e) => { setShiftCode(e.target.value); }} onBlur={() => checkShiftCode(shiftCode)} fullWidth size="small" label="" variant="outlined"
                                                            error={shiftCodeStatus === true} // highlight in red
                                                            helperText={shiftCodeStatus === true ? "Code already exists" : ""} // message
                                                        />
                                                    </Grid>
                                                </Grid>

                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                                    <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                        <Typography variant="h6">Check-In & Out Time</Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={1.4} lg={1.5} xl={1} >
                                                        <FormControl size="small" >
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <TimePicker
                                                                    placeholder="Check-In Time"
                                                                    value={checkInTime}
                                                                    onChange={(newValue) => setCheckInTime(newValue)}
                                                                    slotProps={{ textField: { size: 'small' } }}
                                                                />
                                                            </LocalizationProvider>
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item xs={12} sm={11} md={.1} lg={0.1} xl={0.1} >
                                                        <Typography>-</Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={1.4} lg={1.5} xl={1} >
                                                        <FormControl size="small">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <TimePicker
                                                                    placeholder="Check-Out Time"
                                                                    value={checkOutTime}
                                                                    onChange={(newValue) => {
                                                                        setCheckOutTime(newValue);
                                                                        //handleCalculateDuration();
                                                                    }}
                                                                    slotProps={{ textField: { size: 'small' } }}
                                                                />
                                                            </LocalizationProvider>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                    <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                        <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                            Grace Time Duration (mins)
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={11} md={3.8} lg={1.5} xl={1}>
                                                        <TextField value={breakDurationMins} onChange={(e) => { setBreakDurationMins(e.target.value) }} required type="number" fullWidth size="small" label="" variant="outlined" inputProps={{ min: 0 }} />
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                    <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                        <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                            Description
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={11} md={3.8} lg={5} xl={4}>
                                                        <TextField value={description} onChange={(e) => { setDescription(e.target.value) }} fullWidth size="small" multiline label="" required variant="outlined" />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                                        <Grid item xs={12} sm={11} md={12} lg={12} xl={12} display="flex-start" justifyContent="center">
                                            <Box mt={1}  >

                                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                                    <Tabs
                                                        value={value}
                                                        onChange={handleChange}
                                                        indicatorColor="secondary"
                                                        textColor="inherit"
                                                        variant="contained"
                                                        aria-label="full width tabs example"
                                                    >
                                                        <Tab sx={{ textTransform: "none" }} label="Break Details" {...a11yProps(0)} />

                                                    </Tabs>
                                                </Box>

                                                <SwipeableViews
                                                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                                    index={value}
                                                    onChangeIndex={handleChangeIndex}
                                                >
                                                    <TabPanel value={value} index={0} dir={theme.direction}>
                                                        <Box>
                                                            <Grid container spacing={1}>
                                                                <Grid item xs={12}>
                                                                    <CustomTableContainer colors={colors}>
                                                                        <TableContainer>
                                                                            <Table size="small">
                                                                                <TableHead>
                                                                                    <TableRow sx={{ backgroundColor: colors.primary[400] }}>
                                                                                        <TableCell>Break Type</TableCell>
                                                                                        <TableCell>Start Time</TableCell>
                                                                                        <TableCell>End Time</TableCell>
                                                                                        <TableCell>Status</TableCell>
                                                                                        <TableCell>Action</TableCell>
                                                                                    </TableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {breaks.map((row, index) => (
                                                                                        <TableRow key={index}>

                                                                                            {/* Break Type */}
                                                                                            <TableCell>
                                                                                                <FormControl fullWidth size="small">
                                                                                                    <Select
                                                                                                        value={row.break_type_id}
                                                                                                        onChange={(e) =>
                                                                                                            updateBreakField(index, 'break_type_id', e.target.value)
                                                                                                        }
                                                                                                        displayEmpty
                                                                                                    >
                                                                                                        <MenuItem value="" disabled>Select Break</MenuItem>
                                                                                                        {breakTypeList.map((type) => (
                                                                                                            <MenuItem key={type.id_break_type} value={type.id_break_type}>
                                                                                                                {type.code}
                                                                                                            </MenuItem>
                                                                                                        ))}
                                                                                                    </Select>
                                                                                                </FormControl>
                                                                                            </TableCell>

                                                                                            {/* Start Time */}
                                                                                            <TableCell>
                                                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                                    <TimePicker
                                                                                                        value={dayjs(row.break_start_time, 'HH:mm:ss')}
                                                                                                        onChange={(newValue) =>
                                                                                                            updateBreakField(index, 'break_start_time', newValue)
                                                                                                        }
                                                                                                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                                                                                    />
                                                                                                </LocalizationProvider>
                                                                                            </TableCell>

                                                                                            {/* End Time */}
                                                                                            <TableCell>
                                                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                                    <TimePicker
                                                                                                        value={dayjs(row.break_end_time, 'HH:mm:ss')}
                                                                                                        onChange={(newValue) =>
                                                                                                            updateBreakField(index, 'break_end_time', newValue)
                                                                                                        }
                                                                                                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                                                                                    />
                                                                                                </LocalizationProvider>
                                                                                            </TableCell>

                                                                                            {/* Status */}
                                                                                            <TableCell>
                                                                                                <FormControl fullWidth size="small">
                                                                                                    <Select
                                                                                                        value={row.status}
                                                                                                        onChange={(e) =>
                                                                                                            updateBreakField(index, 'status', e.target.value)
                                                                                                        }
                                                                                                    >
                                                                                                        <MenuItem value="Active">Active</MenuItem>
                                                                                                        <MenuItem value="Inactive">Inactive</MenuItem>
                                                                                                    </Select>
                                                                                                </FormControl>
                                                                                            </TableCell>

                                                                                            {/* Delete */}
                                                                                            <TableCell>
                                                                                                <IconButton color="error" onClick={() => deleteBreakRow(index)}>
                                                                                                    <Delete />
                                                                                                </IconButton>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    ))}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    </CustomTableContainer>

                                                                </Grid>

                                                                <Grid item xs={12}>
                                                                    <Button variant="outlined" color="secondary" startIcon={<Add />} onClick={addBreakRow}>
                                                                        Add Break
                                                                    </Button>
                                                                </Grid>

                                                            </Grid>
                                                        </Box>
                                                    </TabPanel>

                                                </SwipeableViews>
                                            </Box>

                                        </Grid>

                                    </Grid>
                                </Grid>
                            </>
                        )}
                </Grid>

            </ResponsiveBox>
        </Box>
    );

}
export default ShiftMasterForm;